
import { Directive, ElementRef, Input } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';

@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective {
  public constructor(private host: ElementRef, private sharedService: SharedService) { }

  @Input('appAutoFocus') selector: string;
  ngAfterViewInit(): void {
    if (!!this.appAutoFocus)
      if ((<any>this.host).focus)
        (<any>this.host).focus();
    else this.host?.nativeElement.focus();
  }

  @Input() appAutoFocus: boolean;
}
